import { RemoteApiError } from "../useRemote/types";
import { useRemoteMutation } from "../useRemote/useRemoteMutation";
import { useTranslation } from "react-i18next";

export function useRemoteDeleteBookingVisitors(visitorId: number) {
  const { t } = useTranslation();

  return useRemoteMutation<void, RemoteApiError, any>({
    key: "useRemoteDeleteBookingVisitors",
    method: "delete",
    url: `/booking-schedule/no-place-zone-booking-guests/${visitorId}`,
    snackbarTextOnSuccess: t("Successfully deleted booking"),
    snackbarTextOnFail: t("Error while deleting your booking")
  });
}
